import { createContext, useContext, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  /** */

  // Detect System Locale
  const systemLanguage = navigator.language || navigator.userLanguage || "en"; // en-US, tr-TR
  const systemLocale = systemLanguage.split("-")[0]; // en, tr

  // App Locale (Persisted User Selection -> System Locale -> Default Locale)
  const [locale, setLocale] = useState(localStorage.getItem("locale") || systemLocale || "en");

  // Handle Update Locale
  const handleUpdateLocale = (code) => {
    setLocale(code);
    localStorage.setItem("locale", code);
  };

  return (
    <AppContext.Provider
      value={{
        locale,
        setLocale: handleUpdateLocale,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
